<template>
  <b-row v-if="Array.isArray(jobs)" class="px-3">
    <b-col v-for="job in jobs" :key="job.id" cols="12" md="4" class="px-2">
      <job-item :job="job" layout="tiny" />
    </b-col>
    <b-col class="px-2" v-if="jobs.length < 3" cols="12" :md="(12 - 4 * jobs.length)">
      <b-card
        class="h-100 p-5 text-center d-flex flex-column justify-content-center align-items-center"
        style="min-height: 260px"
        no-body
      >
        <div>
          <div v-if="!jobs.length">It looks like we don't have any opportunities that fit your profile right now.</div>
          <div v-else>It looks like we have {{ jobs.length }} {{ jobs.length === 1 ? 'opportunity' : 'opportunities' }} that {{ jobs.length === 1 ? 'fits' : 'fit' }} your profile right now.</div>
          <div>To see more we recommend you to <b-link :to="{ name: 'ProfileEdit' }">keep your profile updated</b-link>.</div>
          <div>or</div>
          <div>You can visit the <b-link :to="{ name: 'InternalJobIndex' }">job page for all the internal opportunities</b-link>.</div>
        </div>
      </b-card>
    </b-col>
    <b-col cols="12" class="px-2">
      <b-button
        class="float-right mt-3 px-4"
        variant="outline-primary"
        :to="{ name: 'InternalJobIndex' }"
      >View All</b-button>
    </b-col>
  </b-row>
</template>

<script>
import JobItem from '@/components/jobs/UserMatchListItem.vue';

export default {
  props: {
    jobs: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    JobItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/SuggestedJobs.vue